<template>
  <div class="full-page" :class="{ 'nav-open': $sidebar.showSidebar }">
    <div
      class="md-toolbar md-elevation-0 md-transparent md-toolbar-absolute"
      v-if="false"
    >
      <div class="md-toolbar-row md-offset">
        <div class="md-toolbar-section-start">
          <h3 class="md-title">{{ $route.name }}</h3>
        </div>
        <div class="md-toolbar-section-end">
          <button
            class="md-button md-just-icon md-simple md-round md-toolbar-toggle"
            :class="{ toggled: $sidebar.showSidebar }"
            @click="toggleSidebar"
          >
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>

          <div
            class="md-collapse"
            :class="{ 'off-canvas-sidebar': responsive }"
          >
            <ul class="md-list">
              <li class="md-list-item">
                <a href="/">
                  <i class="material-icons">dashboard</i>
                  Dashboard
                </a>
              </li>
              <li class="md-list-item">
                <a href="#/pricing" @click="linkClick">
                  <i class="material-icons">attach_money</i>
                  Pricing
                </a>
              </li>
              <li class="md-list-item">
                <a href="#/register" @click="linkClick">
                  <i class="material-icons">person_add</i>
                  Register
                </a>
              </li>
              <li class="md-list-item">
                <a href="#/login" @click="linkClick">
                  <i class="material-icons">fingerprint</i>
                  login
                </a>
              </li>
              <li class="md-list-item">
                <a href="#/lock" @click="linkClick">
                  <i class="material-icons">lock_open</i>
                  lock
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="wrapper wrapper-full-page" @click="toggleSidebarPage">
      <div
        id="bannerimagecintainer"
        class="page-header header-filter"
        :class="[
          setPageClass,
          { 'login-custom-bg': isAuthBackgroundRoute && hasCustomLoginBackground },
        ]"
        filter-color="black"
        :style="loginPageCustomBackgroundStyle"
      >
        <video
          v-if="showBackgroundVideo"
          ref="backgroundVideo"
          class="background-video"
          autoplay
          muted
          loop
          playsinline
          style="opacity: 1"
        >
          <source src="/img/puerto.mp4" type="video/mp4" />
        </video>

        <div class="container md-offset">
          <zoom-center-transition
            :duration="pageTransitionDuration"
            mode="out-in"
          >
            <router-view></router-view>
          </zoom-center-transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ZoomCenterTransition } from "vue2-transitions";
import { wencesApi } from "@/api/wencesApi";

export default {
  async created() {
    if (this.$router.currentRoute.params.type == "gym") {
      this.typeregister = "/img/register.jpg";
    }
    await this.loadSettings();
  },
  components: {
    ZoomCenterTransition,
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black",
    },
  },
  inject: {
    autoClose: {
      default: true,
    },
  },
  data() {
    return {
      typeregister: "/img/lock.jpg",
      responsive: false,
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 300,
      year: new Date().getFullYear(),
      videoPlayed: false,
      site: null,
      settingsLoaded: false,
    };
  },
  computed: {
    isAuthBackgroundRoute() {
      return this.$route.name === "Login" || this.$route.name === "Register";
    },
    hasCustomLoginBackground() {
      const img = this.site?.loginBackgroundImage;
      return !!(img && String(img).trim());
    },
    /** Fondo de auth a pantalla completa (contain); login y register. */
    loginPageCustomBackgroundStyle() {
      if (!this.isAuthBackgroundRoute || !this.hasCustomLoginBackground) {
        return {};
      }
      return {
        backgroundImage: `url(${String(this.site.loginBackgroundImage).trim()})`,
        backgroundSize: "contain",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#000",
      };
    },
    showBackgroundVideo() {
      if (!this.settingsLoaded) return false;
      if (this.isAuthBackgroundRoute && this.hasCustomLoginBackground) {
        return false;
      }
      return true;
    },
    setBgImage() {
      let images = {
        Pricing: "/img/bg-pricing.jpg",
        Login: "/img/lock.jpg",
        Register: this.typeregister,
        Lock: "/img/lock.jpg",
        PersonalTrainers: "/img/blueback.jpg",
      };
      let bg = images[this.$route.name];
      if (bg == undefined) {
        bg = "/img/lock.jpg";
      }

      return {
        backgroundImage: `url(${bg})`,
      };
    },
    setPageClass() {
      return `${this.$route.name}-page`.toLowerCase();
    },
  },
  methods: {
    async loadSettings() {
      try {
        const response = await wencesApi.get("/api/settings");
        this.site = response.data.data;
      } catch (error) {
        console.error("Error loading settings:", error);
      } finally {
        this.settingsLoaded = true;
      }
    },
    toggleSidebarPage() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    linkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    async playVideo() {
      if (!this.showBackgroundVideo || !this.$refs.backgroundVideo) return;
      try {
        await this.$refs.backgroundVideo.play();
        this.videoPlayed = true;
        this.$refs.backgroundVideo.style.opacity = "1";
      } catch (error) {
        console.error("Error playing video:", error);
        setTimeout(() => this.playVideo(), 1000);
      }
    },
    handleVideoError() {
      if (this.$refs.backgroundVideo) {
        this.$refs.backgroundVideo.style.display = "none";
      }
    },
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);

    // Intentar reproducir el video inmediatamente después del montaje
    this.$nextTick(() => {
      this.playVideo();
    });

    // Intentar reproducir el video cuando el usuario interactúe con la página
    document.addEventListener("click", this.playVideo);
    document.addEventListener("touchstart", this.playVideo);
    document.addEventListener("keydown", this.playVideo);
  },
  beforeDestroy() {
    this.closeMenu();
    window.removeEventListener("resize", this.onResponsiveInverted);

    // Limpiar los event listeners
    document.removeEventListener("click", this.playVideo);
    document.removeEventListener("touchstart", this.playVideo);
    document.removeEventListener("keydown", this.playVideo);
  },
  beforeRouteUpdate(to, from, next) {
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  watch: {
    showBackgroundVideo(show) {
      if (show) {
        this.$nextTick(() => this.playVideo());
      }
    },
  },
};
</script>
<style lang="scss">
body {
  background-color: transparent !important;
}
</style>
<style lang="scss" scoped>
$scaleSize: 0.1;
$zoomOutStart: 0.7;
$zoomOutEnd: 0.46;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
    transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
  }
  to {
    opacity: 0;
    transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}

.background-video {
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: 0;
  object-fit: cover;
}

.background-video.playing {
  opacity: 1;
}

.page-header {
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.page-header:not(.login-custom-bg) {
  background: transparent !important;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.wrapper-full-page {
  background: transparent !important;
}

/* Sin fondo custom el video se ve; con .login-custom-bg el :style del header define la imagen */
#bannerimagecintainer:not(.login-custom-bg) {
  background: transparent !important;
}

#bannerimagecintainer.login-custom-bg {
  background-size: cover !important;
  background-repeat: no-repeat !important;
}

.full-page {
  background: transparent !important;
}

:deep(body) {
  background-color: transparent !important;
}
</style>
